import { render, staticRenderFns } from "./UserGilBill.vue?vue&type=template&id=6711a0bb&"
import script from "./UserGilBill.vue?vue&type=script&lang=js&"
export * from "./UserGilBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports